<template>
  <div class="ls-box">
    <form class="ls-form" @submit.prevent="validateBeforeSubmit" >
      <h5 class="ls-title-5 ls-lg-margin-bottom" :class="{ 'ls-color-theme' : !$parent.$data.forms.submitted.signup }"><i class="fa fa-user-o" aria-hidden="true"></i> {{ $t('subscribe.titles.identify') }}</h5>
      <div class="fields">
        <div class="row">
          <div class="col-md-8 col-xs-12">

            <MaterialInput
              disabled
              type="email"
              name="email"
              v-model="$parent.$data.email"
              ico="fa fa-envelope-o">
                {{ $t('subscribe.attributes.email') }}
                <i class="fa fa-check" slot="ico-check" aria-hidden="true"></i>
            </MaterialInput>

          </div>
          <div class="col-md-4 ls-md-margin-bottom ls-display-inline-block ls-display-none-xs">
            <p><a href="javascript:void(0)" class="ls-text-xs" @click="$parent.backToEmailForm">{{ $t('subscribe.attributes.choose_another_email') }}</a></p>
          </div>
        </div>

        <div class="ls-clearfix"></div>


        <label class="ls-label ls-no-bold ls-text-xs ls-lg-margin-bottom">
          <input type="checkbox" name="business_people" v-model="isBusiness" :disabled="lockBusiness || $parent.$data.forms.submitted.signup"> {{ $t('subscribe.attributes.register_as_legal_entity') }}
        </label>

        <div class="ls-display-flex flex-wrap-wrap">

          <div class="col-lg-12 pl-0" v-if="!$parent.$data.id">
            <MaterialInput
              type="password"
              ico="fa fa-lock"
              label="Password"
              :disabled="$parent.$data.forms.submitted.signup"
              v-model="$parent.$data.password"
              v-validate="'required|min:6'"
              :class="{ 'material--active material--has-errors': errors.has($t('subscribe.attributes.password')) }"
              :data-vv-name="$t('subscribe.attributes.password')">
              {{ $t('subscribe.attributes.password') }}
              <small class="material-errors" slot="help-message" v-if="errors.has($t('subscribe.attributes.password'))">{{ errors.first($t('subscribe.attributes.password')) }}</small>
              <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('subscribe.attributes.password')) && $parent.$data.password" aria-hidden="true"></i>
            </MaterialInput>
          </div>

          <div class="p-0" v-if="isBusiness">

            <div class="col-lg-6 pl-0">
              <MaterialInput
                type="text"
                ico="fa fa-building-o"
                focused="true"
                :disabled="$parent.$data.forms.submitted.signup"
                v-validate="'required'"
                v-model="$parent.$data.company_name"
                :class="{ 'material--active material--has-errors': errors.has($t('subscribe.attributes.company_name')) }"
                :data-vv-name="$t('subscribe.attributes.company_name')"
                :required="false">
                  {{ $t('subscribe.attributes.company_name') }}
                <small class="material-errors" slot="help-message" v-if="errors.has($t('subscribe.attributes.company_name'))">{{ errors.first($t('subscribe.attributes.company_name')) }}</small>
                <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('subscribe.attributes.company_name')) && $parent.$data.company_name" aria-hidden="true"></i>
              </MaterialInput>
            </div>

            <div class="col-lg-6 pl-0">
              <MaterialInput
                type="text"
                ico="fa fa-briefcase"
                focused="true"
                :disabled="$parent.$data.forms.submitted.signup"
                v-model="$parent.$data.tradeName"
                v-validate="'required'"
                :class="{ 'material--active material--has-errors': errors.has($t('subscribe.attributes.trade_name')) }"
                :data-vv-name="$t('subscribe.attributes.trade_name')"
                >
                {{ $t('subscribe.attributes.trade_name') }}
                <small class="material-errors" slot="help-message" v-if="errors.has($t('subscribe.attributes.trade_name'))">{{ errors.first($t('subscribe.attributes.trade_name')) }}</small>
                <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('subscribe.attributes.trade_name')) && $parent.$data.tradeName" aria-hidden="true"></i>
              </MaterialInput>
            </div>

            <div class="col-lg-6 pl-0">
              <MaterialInput
                type="tel"
                ico="fa fa-id-card"
                maxlength="18"
                :disabled="$parent.$data.forms.submitted.signup"
                v-mask="'99.999.999/9999-99'"
                v-validate="'required|cnpj'"
                v-model="$parent.$data.cnpj"
                :class="{ 'material--active material--has-errors': errors.has($t('subscribe.attributes.cnpj')) }"
                :data-vv-name="$t('subscribe.attributes.cnpj')"
                :required="false">
                  {{ $t('subscribe.attributes.cnpj') }}
                  <small class="material-errors" slot="help-message" v-if="errors.has($t('subscribe.attributes.cnpj'))">{{ errors.first($t('subscribe.attributes.cnpj')) }}</small>
                  <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('subscribe.attributes.cnpj')) && $parent.$data.cnpj" aria-hidden="true"></i>
              </MaterialInput>
            </div>
            
            <div class="col-lg-12 pl-0">
              <h3 class="ls-lg-margin-bottom">{{ $t('customers.main.optional_personal_info') }}</h3>
            </div>

            <div class="col-lg-6 pl-0">
              <MaterialInput
                type="tel"
                maxlength="14"
                :disabled="$parent.$data.forms.submitted.signup"
                focused="true"
                ico="fa fa-id-card-o"
                :required="false"
                v-mask="'999.999.999-99'"
                v-model="$parent.$data.cpf"
                v-validate="'min:14|cpf|cpfInUse'"
                :class="{ 'material--active material--has-errors': errors.has($t('subscribe.attributes.cpf')) }"
                :data-vv-name="$t('subscribe.attributes.cpf')">
                {{ $t('subscribe.attributes.cpf') }}
                <small class="material-errors" slot="help-message" v-if="errors.has($t('subscribe.attributes.cpf'))">{{ errors.first($t('subscribe.attributes.cpf')) }}</small>
                <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('subscribe.attributes.cpf')) && $parent.$data.cpf" aria-hidden="false"></i>
              </MaterialInput>
            </div>
            
            <div class="col-lg-6 pl-0">
              <MaterialInput
                type="text"
                label="Name"
                :disabled="$parent.$data.forms.submitted.signup"
                ico="fa fa-user-o"
                :required="false"
                v-validate="'alpha_spaces|min:2'"
                v-model="$parent.$data.name"
                :class="{ 'material--active material--has-errors': errors.has($t('subscribe.attributes.name')) }"
                :data-vv-name="$t('subscribe.attributes.name')">
                {{ $t('subscribe.attributes.name') }}
                <small class="material-errors" slot="help-message" v-if="errors.has($t('subscribe.attributes.name'))">{{ errors.first($t('subscribe.attributes.name')) }}</small>
                <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('subscribe.attributes.name')) && $parent.$data.name" aria-hidden="true"></i>
              </MaterialInput>
            </div>
          </div>
          
          <div class="col-lg-6 pl-0">
            <MaterialInput
              type="tel"
              maxlength="14"
              focused="true"
              v-if="!isBusiness"
              ico="fa fa-id-card-o"
              v-mask="'999.999.999-99'"
              v-model="$parent.$data.cpf"
              v-validate="'required|min:14|cpf|cpfInUse'"
              :class="{ 'material--active material--has-errors': errors.has($t('subscribe.attributes.cpf')) }"
              :data-vv-name="$t('subscribe.attributes.cpf')">
              {{ $t('subscribe.attributes.cpf') }}
              <small class="material-errors" slot="help-message" v-if="errors.has($t('subscribe.attributes.cpf'))">{{ errors.first($t('subscribe.attributes.cpf')) }}</small>
              <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('subscribe.attributes.cpf')) && $parent.$data.cpf" aria-hidden="false"></i>
            </MaterialInput>
          </div>

          <div class="col-lg-6 pl-0">
            <MaterialInput
              :disabled="$parent.$data.forms.submitted.signup"
              type="text"
              label="Name"
              ico="fa fa-user-o"
              v-if="!isBusiness"
              v-validate="'alpha_spaces|min:2'"
              v-model="$parent.$data.name"
              :class="{ 'material--active material--has-errors': errors.has($t('subscribe.attributes.name')) }"
              :data-vv-name="$t('subscribe.attributes.name')">
                {{ $t('subscribe.attributes.name') }}
                <small class="material-errors" slot="help-message" v-if="errors.has($t('subscribe.attributes.name'))">{{ errors.first($t('subscribe.attributes.name')) }}</small>
                <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('subscribe.attributes.name')) && $parent.$data.name" aria-hidden="true"></i>
            </MaterialInput>
          </div>

          <div class="col-lg-6 pl-0">
            <MaterialInput
              :disabled="$parent.$data.forms.submitted.signup"
              type="tel"
              ico="fa fa-phone"
              maxlength="16"
              v-model="$parent.$data.fullPhone"
              v-validate="'min:14'"
              :required="false"
              :v-mask="phoneMask"
              :class="{ 'material--active material--has-errors': errors.has($t('subscribe.attributes.phone')) }"
              :data-vv-name="$t('subscribe.attributes.phone')">
              {{ $t('subscribe.attributes.phone') }}
              <small class="material-errors" slot="help-message" v-if="errors.has($t('subscribe.attributes.phone'))">{{ errors.first($t('subscribe.attributes.phone')) }}</small>
              <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('subscribe.attributes.phone')) && $parent.$data.fullPhone" aria-hidden="true"></i>
            </MaterialInput>
          </div>
          
          <div class="col-lg-12 pl-0">
            <h3 class="ls-lg-margin-bottom">Endereço</h3>
          </div>

          <MaterialInput
            :disabled="$parent.$data.forms.submitted.signup"
            type="tel"
            maxlength="10"
            focused="true"
            ico="fa fa-map-pin"
            v-mask="'99.999-999'"
            v-model="$parent.$data.postalCode"
            v-validate="'required|min:10|cep'"
            :class="{ 'material--active material--has-errors': errors.has($t('subscribe.attributes.post_code')) }"
            :data-vv-name="$t('subscribe.attributes.post_code')">
              {{ $t('subscribe.attributes.post_code') }}
              <small class="material-errors" slot="help-message" v-if="errors.has($t('subscribe.attributes.post_code'))">{{ errors.first($t('subscribe.attributes.post_code')) }}</small>
              <i class="fa fa-check" slot="ico-check" v-if="showAddressDetails" aria-hidden="true"></i>
          </MaterialInput>

          <div v-if="showAddressDetails" class="fields row">
            <div class="col-md-8">
              <MaterialInput
                :disabled="$parent.$data.forms.submitted.signup"
                type="text"
                ico="fa icon icon-house"
                v-model="$parent.$data.street"
                v-validate="'required'"
                :class="{ 'material--active material--has-errors': errors.has($t('subscribe.attributes.street')) }"
                :data-vv-name="$t('subscribe.attributes.street')"
                :focused="focusStreet">
                  {{ $t('subscribe.attributes.street') }}
                  <small class="material-errors" slot="help-message" v-if="errors.has($t('subscribe.attributes.street'))">{{ errors.first($t('subscribe.attributes.street')) }}</small>
                  <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('subscribe.attributes.street')) && $parent.$data.street.length" aria-hidden="true"></i>
              </MaterialInput>

            </div>

            <div class="col-md-3">
              <MaterialInput
                :disabled="$parent.$data.forms.submitted.signup"
                type="tel"
                maxlength="10"
                v-validate="'required|numeric'"
                v-model="$parent.$data.number"
                ico="fa icon icon-number"
                :class="{ 'material--active material--has-errors': errors.has($t('subscribe.attributes.number')) }"
                :data-vv-name="$t('subscribe.attributes.number')"
                :focused="focusNumber">
                  {{ $t('subscribe.attributes.number') }}
                  <small class="material-errors" slot="help-message" v-if="errors.has($t('subscribe.attributes.number'))">{{ errors.first($t('subscribe.attributes.number')) }}</small>
                  <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('subscribe.attributes.number')) && $parent.$data.number.length" aria-hidden="true"></i>
              </MaterialInput>
            </div>

            <div class="col-md-8">
              <MaterialInput
                :disabled="$parent.$data.forms.submitted.signup"
                type="tel"
                ico="fa icon icon-neighborhood"
                v-validate="'required'"
                v-model="$parent.$data.neighborhood"
                :class="{ 'material--active material--has-errors': errors.has($t('subscribe.attributes.neighborhood')) }"
                :data-vv-name="$t('subscribe.attributes.neighborhood')"
                :focused="focusNeighborhood">
                  {{ $t('subscribe.attributes.neighborhood') }}
                  <small class="material-errors" slot="help-message" v-if="errors.has($t('subscribe.attributes.neighborhood'))">{{ errors.first($t('subscribe.attributes.neighborhood')) }}</small>
                  <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('subscribe.attributes.neighborhood')) && $parent.$data.neighborhood.length" aria-hidden="true"></i>
                </MaterialInput>
            </div>

            <div class="col-md-3">
              <MaterialInput
                :disabled="$parent.$data.forms.submitted.signup"
                type="text"
                name="complement"
                v-model="$parent.$data.complement"
                ico="fa icon icon-cityscape"
                :required="false">
                  {{ $t('subscribe.attributes.complement') }}
              </MaterialInput>
            </div>

            <div class="col-md-8">
              <MaterialInput
                :disabled="$parent.$data.forms.submitted.signup"
                type="text"
                ico="fa icon icon-cityscape"
                v-validate="'required'"
                v-model="$parent.$data.city"
                :class="{ 'material--active material--has-errors': errors.has($t('subscribe.attributes.city')) }"
                :data-vv-name="$t('subscribe.attributes.city')"
                :focused="focusCity">
                  {{ $t('subscribe.attributes.city') }}
                  <small class="material-errors" slot="help-message" v-if="errors.has($t('subscribe.attributes.city'))">{{ errors.first($t('subscribe.attributes.city')) }}</small>
                  <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('subscribe.attributes.city')) && $parent.$data.city.length" aria-hidden="true"></i>
              </MaterialInput>
            </div>

            <div class="col-md-3">
              <MaterialInput
                type="select"
                :disabled="$parent.$data.forms.submitted.signup"
                v-validate="'required'"
                v-model="$parent.$data.state"
                ico="fa icon icon-state"
                :focused="focusState"
                :class="{ 'material--active material--has-errors': errors.has($t('subscribe.attributes.state')) }"
                :data-vv-name="$t('subscribe.attributes.state')">
                {{ $t('subscribe.attributes.state') }}
                <option slot="options" value="AC">AC</option>
                <option slot="options" value="AL">AL</option>
                <option slot="options" value="AP">AP</option>
                <option slot="options" value="AM">AM</option>
                <option slot="options" value="BA">BA</option>
                <option slot="options" value="CE">CE</option>
                <option slot="options" value="DF">DF</option>
                <option slot="options" value="ES">ES</option>
                <option slot="options" value="GO">GO</option>
                <option slot="options" value="MA">MA</option>
                <option slot="options" value="MS">MS</option>
                <option slot="options" value="MG">MG</option>
                <option slot="options" value="MT">MT</option>
                <option slot="options" value="PA">PA</option>
                <option slot="options" value="PB">PB</option>
                <option slot="options" value="PR">PR</option>
                <option slot="options" value="PE">PE</option>
                <option slot="options" value="PI">PI</option>
                <option slot="options" value="RJ">RJ</option>
                <option slot="options" value="RN">RN</option>
                <option slot="options" value="RS">RS</option>
                <option slot="options" value="RO">RO</option>
                <option slot="options" value="RR">RR</option>
                <option slot="options" value="SC">SC</option>
                <option slot="options" value="SP">SP</option>
                <option slot="options" value="SE">SE</option>
                <option slot="options" value="TO">TO</option>
                <small class="material-errors" slot="help-message" v-if="errors.has($t('subscribe.attributes.state'))">{{ errors.first($t('subscribe.attributes.state')) }}</small>
                <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('subscribe.attributes.state')) && $parent.$data.state.length" aria-hidden="true"></i>
              </MaterialInput>
            </div>
          </div>
        </div>

        <div class="btn-action" v-if="!$parent.$data.forms.submitted.signup">
          <button type="button" @click="$parent.backToEmailForm" class="btn prev btn-fixed-bottom-xs ls-display-none-sm ls-display-none-md ls-display-none-lg"><span class="ls-ico-chevron-left"></span>{{ $t('subscribe.buttons.change_email') }}</button>
          <button class="btn btn-act next ls-display-none-xs">Salvar</button>
          <button class="btn btn-act next btn-fixed-bottom-xs ls-display-none-sm ls-display-none-md ls-display-none-lg">Salvar<span class="ls-ico-chevron-right"></span></button>
        </div>
      </div>
    </form>
    <div class="ls-display-none-xs" v-if="$parent.$data.forms.submitted.signup">
      <button class="ls-btn ls-btn-primary" @click="windowFocus()">{{ $t('application.button.change') }}</button>
    </div>
  </div>
</template>
<script>
  import MaterialInput from '../../../components/shareds/MaterialInput.vue'
  import * as format from 'src/utils/form'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'signup-form',
    components: { MaterialInput },
    data () {
      return {
        onlyNumber: /[\D]/g,
        isBusiness: false,
        lockBusiness: false,
        cepFound: false,
        changeAddress: false,
        phoneMask: '',
        parsedCust: {}
      }
    },
    computed: {
      ...mapGetters(['addressFound']),
      showAddressDetails () {
        return !this.errors.has(this.$t('subscribe.attributes.post_code')) && this.$parent.$data.postalCode && this.cepFound
      },
      focusStreet () {
        return (this.emptyField('street')).toString()
      },
      focusNumber () {
        return (!this.emptyField('street') && this.emptyField('number')).toString()
      },
      focusNeighborhood () {
        return (!this.emptyField('street') && !this.emptyField('number') && this.emptyField('neighborhood')).toString()
      },
      focusCity () {
        return (!this.emptyField('street') && !this.emptyField('number') && !this.emptyField('neighborhood') &&
          this.emptyField('city')).toString()
      },
      focusState () {
        return (!this.emptyField('street') && !this.emptyField('number') && !this.emptyField('neighborhood') &&
          !this.emptyField('city') && this.emptyField('state')).toString()
      }
    },
    methods: {
      ...mapActions(['createCustomer', 'editCustomer']),
      validateBeforeSubmit () {
        this.$loader.show()
        this.$validator.validate().then(this.afterValidate)
      },
      endAction (response) {
        if (response.status === 422) {
          this.$loader.hide()
          return
        }
        this.$parent.forms.submitted.signup = true
        let customer = JSON.parse(window.localStorage.customer)
        if (!customer.address) {
          this.$parent.forms.payment = true
        }
        this.$loader.hide()
      },
      emptyField (field) {
        return (!this.$parent.$data[field] || this.$parent.$data[field].length === 0)
      },
      windowFocus () {
        let customer = JSON.parse(window.localStorage.customer)
        if (customer.address) this.$parent.$data.forms.submitted.address = true
        this.$parent.$data.forms.submitted.signup = false
      },
      clearBusinessFields () {
        this.$parent.$data.kind = 'C'

        if (this.isBusiness) return
        this.$parent.$data.cnpj = ''
        this.$parent.$data.tradeName = ''
        this.$parent.$data.companyName = ''
        this.$parent.$data.kind = 'P'
      },
      formatFields () {
        this.formatPhone()
        this.formatCpf()
        this.formatCnpj()
      },
      loadCutomerType () {
        if (this.$parent.$data.kind === 'C') { this.isBusiness = true }
      },
      formatPhone () {
        if (!this.$parent.$data.fullPhone) return
        this.$parent.$data.fullPhone = format.formatPhone(this.$parent.$data.fullPhone)
      },
      formatCpf () {
        if (this.$parent.$data.cpf) this.$parent.$data.cpf = format.cpf(this.$parent.$data.cpf)
      },
      formatCnpj () {
        if (this.$parent.$data.cnpj) this.$parent.$data.cnpj = format.cnpj(this.$parent.$data.cnpj)
      },
      // Metodo finaliza a criacao ou edicao do customer
      afterValidate (response) {
        if (response === false) {
          this.$loader.hide()
          return
        }
        this.parseCustomerAttributes()
        this.createOrUpdate().then(this.endAction)
      },
      createOrUpdate () {
        this.$store.state.auth.customerToken = window.localStorage.customerToken
        let params = { customer: this.parsedCust, requestType: 'customer' }
        if (window.localStorage.customer) {
          return Promise.resolve(this.editCustomer(params))
        } else {
          return Promise.resolve(this.createCustomer(this.parsedCust))
        }
      },
      // Metodo responsavel por montar os atributos do customer de forma correta
      parseCustomerAttributes () {
        this.initializeParsedCust()
        if (this.$parent.$data.fullPhone.length > 0) {
          this.parseContact()
        }
        this.parseAddress()
        this.parseCustAttributes()
      },
      // Inicializa o processo de modelagem dos dados do customer
      initializeParsedCust () {
        this.parsedCust = {
          address_attributes: {},
          contact_attributes: {}
        }
      },
      // Modela os atributos de contato do customer
      parseContact () {
        this.parsedCust.contact_attributes.area_code = this.$parent.$data.fullPhone.substring(0, 4).replace(this.onlyNumber, '')
        this.parsedCust.contact_attributes.number = this.$parent.$data.fullPhone.substring(5).replace(this.onlyNumber, '')
        if (this.$parent.$data.contactId) this.parsedCust.contact_attributes.id = this.$parent.$data.contactId
      },
      parseAddress () {
        this.parsedCust.address_attributes.postal_code = this.$parent.$data.postalCode.replace(this.onlyNumber, '')
        this.parsedCust.address_attributes.street = this.$parent.$data.street
        this.parsedCust.address_attributes.number = this.$parent.$data.number
        this.parsedCust.address_attributes.complement = this.$parent.$data.complement
        this.parsedCust.address_attributes.neighborhood = this.$parent.$data.neighborhood
        this.parsedCust.address_attributes.city = this.$parent.$data.city
        this.parsedCust.address_attributes.state = this.$parent.$data.state

        if (window.localStorage.customer) {
          let customer = JSON.parse(window.localStorage.customer)
          this.parsedCust.sessionTime = customer.access_time
          this.parsedCust.id = customer.id
        }

        if (this.$parent.$data.addressId) this.parsedCust.address_attributes.id = this.$parent.$data.addressId
      },
      // Modela os atributos pessoais do customer
      parseCustAttributes () {
        this.parsedCust.name = this.$parent.$data.name
        this.parsedCust.email = this.$parent.$data.email
        this.parsedCust.cpf = this.$parent.$data.cpf.replace(this.onlyNumber, '')

        if (window.localStorage.customer) {
          let customer = JSON.parse(window.localStorage.customer)
          this.parsedCust.sessionTime = customer.access_time
          this.parsedCust.id = customer.id
        }

        if (this.$parent.$data.id) {
          this.parsedCust.id = this.$parent.$data.id
        } else {
          this.parsedCust.password = this.$parent.$data.password
        }

        if (this.$parent.$data.cnpj) {
          this.parsedCust.cnpj = this.$parent.$data.cnpj.replace(this.onlyNumber, '')
          this.parsedCust.kind = 'C'
          this.parsedCust.trade_name = this.$parent.$data.tradeName
          this.parsedCust.company_name = this.$parent.$data.company_name
        } else {
          this.parsedCust.kind = 'P'
        }
      },
      defineCust () {
        if (this.$parent.$data.id) {
          this.formatFields()
          this.$parent.$data.forms.submitted.signup = true

          if (this.$parent.$data.kind === 'P') return
          this.isBusiness = true
          this.lockBusiness = true
        } else {
          this.errors.clear()
        }
      }
    },
    mounted () {
      if (window.localStorage.customer) this.$parent.loadCustomer()
      window.scrollTo(0, 0)
      this.defineCust()
      this.$loader.hide
    },
    watch: {
      '$parent.$data.fullPhone': function () {
        if (this.$parent.$data.fullPhone === undefined ||
          this.$parent.$data.fullPhone.replace(this.onlyNumber, '').length <= 10) {
          this.phoneMask = '(99) 9999-99999'
        } else {
          this.phoneMask = '(99) 9 9999-9999'
        }
      },
      '$parent.$data.kind': function () {
        if (this.$parent.$data.kind === 'C') {
          this.isBusiness = true
          return
        } else {
          this.isBusiness = false
        }
      },
      addressFound: function (value) {
        if (!value.address) {
          this.$loader.hide()
          return
        }
        if (!this.changeAddress) return
        this.cepFound = true
        if (value.address.street) this.$parent.$data.street = value.address.street || ''
        if (value.address.number) this.$parent.$data.number = value.address.number || ''
        this.$parent.$data.neighborhood = value.address.neighborhood || ''
        this.$parent.$data.complement = value.address.complement || ''
        this.$parent.$data.city = value.address.city || ''
        this.$parent.$data.state = value.address.state || ''
        this.changeAddress = false
        this.cepFound = true
        this.$loader.hide()
      },
      '$parent.$data.postalCode': function (newVal, oldVal) {
        this.cepFound = false

        if (newVal === oldVal) {
          this.changeAddress = false
        } else {
          this.changeAddress = true
          if (newVal.length === 10) this.$loader.show()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SignupForm.vue?8dfadc64